import { Button, Modal } from 'react-bootstrap';
import React, { useState } from "react";


function C4FErrorModal(props) {
  const [show, setShow] = useState(true);

  return (
    <Modal key={show}
      show={show}
      onHide={() => setShow(false)} >
      <Modal.Header closeButton>
        <Modal.Title>{props.type}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Error Code: {props.code}<br></br>
        Error Message: {props.message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShow(false)}>{'OK'}</Button>
      </Modal.Footer>
    </Modal>

  );
}

export default C4FErrorModal;
